import React from 'react';
import { ResponsiveContainer, BarChart, Bar as ReBar, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from 'recharts';

import { barCustomSeries, barChartData } from './data';
import { ChartsHeader } from '../../components';
import { useStateContext } from '../../contexts/ContextProvider';

export const Bar = () => {
  const { currentMode } = useStateContext();

  const seriesNames = barCustomSeries.map((s: any) => s.name || `series${Math.random()}`);
  const combined: any[] = [];
  if (barChartData && barChartData.length > 0) {
    const len = barChartData[0].length;
    for (let i = 0; i < len; i++) {
      const row: any = { x: barChartData[0][i].x };
      barChartData.forEach((seriesArr: any[], si: number) => {
        row[seriesNames[si]] = seriesArr[i] ? seriesArr[i].y : 0;
      });
      combined.push(row);
    }
  }

  const colors = ['#8884d8', '#82ca9d', '#ffc658', '#ff8042'];

  return (
    <div className="m-4 md:m-10 mt-24 p-10 bg-white dark:bg-secondary-dark-bg rounded-3xl">
      <ChartsHeader category="Barra" title="Medalhas Olímpicas - RIO" />
      <div className="w-full" style={{ width: '100%', height: 360, background: currentMode === 'Dark' ? '#33373E' : '#fff', padding: 8, borderRadius: 6 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={combined}>
            <CartesianGrid strokeDasharray="3 3" stroke={currentMode === 'Dark' ? '#444' : '#e6e6e6'} />
            <XAxis dataKey="x" tick={{ fill: currentMode === 'Dark' ? '#d1d5db' : '#374151' }} />
            <YAxis tick={{ fill: currentMode === 'Dark' ? '#d1d5db' : '#374151' }} />
            <Tooltip contentStyle={{ backgroundColor: currentMode === 'Dark' ? '#1f2937' : '#fff', borderRadius: 6 }} />
            <Legend wrapperStyle={{ color: currentMode === 'Dark' ? '#eee' : '#333' }} />
            {seriesNames.map((name: string, idx: number) => (
              <ReBar key={name} dataKey={name} fill={colors[idx % colors.length]} />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
